import { render, staticRenderFns } from "./StakingRewardsListItem.vue?vue&type=template&id=b6a1add6&scoped=true&"
import script from "./StakingRewardsListItem.vue?vue&type=script&lang=ts&"
export * from "./StakingRewardsListItem.vue?vue&type=script&lang=ts&"
import style0 from "./StakingRewardsListItem.vue?vue&type=style&index=0&id=b6a1add6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a1add6",
  null
  
)

export default component.exports